var $ = require('jquery');

module.exports = function(url, record_visit, undefined){ // onRenderPage, url, record_visit, undefined
	var html = $(this.next_page.html);
	var new_lg = html.find('.lang__cta').attr('href');
	$('.lang__cta').attr('href', new_lg);
};